/**
 * Reducer function for handling receipt spend actions.
 *
 * @param {Object} state - The current state.
 * @param {Object} action - The action object.
 * @param {string} action.type - The type of action.
 * @param {any} action.payload - The payload of the action.
 * @returns {Object} The updated state.
 */
import {
  RECEIPT_SPEND_REQUEST,
  RECEIPT_SPEND_SUCCESS,
  RECEIPT_SPEND_FAILURE,
  META_RECEIPT_SPEND_REQUEST,
  META_RECEIPT_SPEND_SUCCESS,
  META_RECEIPT_SPEND_FAILURE,
  META_RECEIPT_SPEND_RESET,
  OWNER_DAILY_COUNT_REQUEST,
  OWNER_DAILY_COUNT_SUCCESS,
  OWNER_DAILY_COUNT_FAIL,
  OWNER_DAILY_COUNT_RESET,
  OWNER_AVG_TICKET_REQUEST,
  OWNER_AVG_TICKET_SUCCESS,
  OWNER_AVG_TICKET_FAIL,
  OWNER_AVG_TICKET_RESET
} from '../constants/metaConstants.js'

export const getReceiptSpendReducer = (state = {}, action) => {
  switch (action.type) {
    case RECEIPT_SPEND_REQUEST:
      return { loading: true }

    case RECEIPT_SPEND_SUCCESS:
      return { loading: false, receiptspend: action.payload }

    case RECEIPT_SPEND_FAILURE:
      return { loading: false, error: action.payload }

    default:
      return state
  }
}

export const metaDailyTotalReducer = (state = {}, action) => {
  switch (action.type) {
    case META_RECEIPT_SPEND_REQUEST:
      return { loading: true }
    case META_RECEIPT_SPEND_SUCCESS:
      return { loading: false, dailyTotals: action.payload }
    case META_RECEIPT_SPEND_FAILURE:
      return { loading: false, error: action.payload }
    case META_RECEIPT_SPEND_RESET:
      return { dailyTotals: {} }
    default:
      return state
  }
}

export const metaDailyTotalByOwnerReducer = (state = {}, action) => {
  switch (action.type) {
    case OWNER_DAILY_COUNT_REQUEST:
      return { loading: true }
    case OWNER_DAILY_COUNT_SUCCESS:
      return { loading: false, dailyTotals: action.payload }
    case OWNER_DAILY_COUNT_FAIL:
      return { loading: false, error: action.payload }
    case OWNER_DAILY_COUNT_RESET:
      return { dailyTotals: {} }
    default:
      return state
  }
}

export const ownerAverageTicketReducer = (state = {}, action) => {
  switch (action.type) {
    case OWNER_AVG_TICKET_REQUEST:
      return { loading: true }
    case OWNER_AVG_TICKET_SUCCESS:
      return { loading: false, summary: action.payload }
    case OWNER_AVG_TICKET_FAIL:
      return { loading: false, error: action.payload }
    case OWNER_AVG_TICKET_RESET:
      return { summary: null }
    default:
      return state
  }
}
